// src/pages/Clientes.jsx
// src/pages/Clientes.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Container, Form, Row, Col, Badge } from "react-bootstrap";
import { fetchClientsGrouped } from "../services/clientsApi";
import Hero from "../components/Hero";
import "./Clientes.css";
import "./Home.css";

const ORDER = {
  "Servicios de Vigilancia": 0,
  "Servicios de Limpieza": 1,
};

// Normaliza: minúsculas, sin tildes, colapsa espacios
const norm = (s = "") =>
  s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export default function Clientes() {
  const [groups, setGroups] = useState([]); // [{service_name, clients:[{...}]}]
  const [q, setQ] = useState("");
  const [svcFilter, setSvcFilter] = useState("ALL");

  useEffect(() => {
    fetchClientsGrouped().then(setGroups).catch(console.error);
  }, []);

  const allServices = useMemo(() => groups.map((g) => g.service_name), [groups]);

  const groupsOrdered = useMemo(() => {
    const arr = [...groups];
    arr.sort(
      (a, b) =>
        (ORDER[a.service_name] ?? 99) - (ORDER[b.service_name] ?? 99)
    );
    return arr;
  }, [groups]);

  // ⇩ FILTRO POR PREFIJO (empieza con lo escrito)
  const filtered = useMemo(() => {
    const qn = norm(q);
    return groupsOrdered
      .map((g) => {
        if (svcFilter !== "ALL" && g.service_name !== svcFilter) return null;

        const clients = g.clients.filter((c) => {
          if (!qn) return true;
          const name = norm(c.name || "");
          return name.startsWith(qn);
        });

        return { ...g, clients };
      })
      .filter(Boolean)
      .filter((g) => g.clients.length > 0);
  }, [groupsOrdered, q, svcFilter]);

  const totalShown = useMemo(
    () => filtered.reduce((acc, g) => acc + g.clients.length, 0),
    [filtered]
  );

  const renderSections = () => {
    if (svcFilter === "ALL") {
      return (
        <Row className="gy-5 services-two-col">
          {filtered.map((g) => (
            <Col key={g.service_name} xs={12} lg={6}>
              <ServiceSection group={g} />
            </Col>
          ))}
        </Row>
      );
    }
    return filtered.map((g) => <ServiceSection key={g.service_name} group={g} />);
  };

  return (
    <>
      <Hero
        subtitle="NUESTROS CLIENTES"
        title="Confianza que se construye día a día"
        description="Relaciones sólidas con empresas y personas que protegen lo que más valoran."
        variant="dark"
        align="center"
        height="sm"
      />

      <div className="clients-page">
        <Container className="py-5">
          <Row className="mb-4 g-3 align-items-center">
            <Col md={8}>
              <Form.Control
                type="text"
                placeholder="Empresa…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                className="clients-search"
              />
            </Col>
            <Col md={4}>
              <Form.Select
                value={svcFilter}
                onChange={(e) => setSvcFilter(e.target.value)}
                className="clients-service-select"
              >
                <option value="ALL">Todos</option>
                {allServices.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          {renderSections()}

          <div className="text-end mt-3">
            <span className="count-pill">
              <strong>{totalShown}</strong> clientes
            </span>
          </div>
        </Container>
      </div>
    </>
  );
}

function ServiceSection({ group }) {
  return (
    <section className="service-section mb-5">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="service-title">{group.service_name}</h2>
        <Badge bg="" className="count-badge">
          {group.clients.length} clientes
        </Badge>
      </div>

      <div className="client-list">
        {group.clients.map((c) => (
          <ClientRow key={c.id} client={c} />
        ))}
      </div>
    </section>
  );
}

function ClientRow({ client }) {
  return (
    <div className="client-row">
      <div className="client-left">
        <div className="client-logo">
          {client.logo_url ? (
            <img
              src={
                client.logo_url.startsWith("http")
                  ? client.logo_url
                  : `https://api.sevicol.com.uy${client.logo_url}`
              }
              alt={client.name}
            />
          ) : (
            <span className="client-logo-fallback">
              {(client.name || "?").slice(0, 1)}
            </span>
          )}
        </div>
        <div className="client-name">{client.name}</div>
      </div>

      <div className="client-tags">
        {(client.branches || []).map((b) => {
          const city = b.city ? ` · ${b.city}` : "";
          return (
            <span key={b.id} className="branch-tag">
              <i className="bi bi-geo-alt-fill" />
              {b.name}
              {city}
            </span>
          );
        })}
      </div>
    </div>
  );
}






